<div class="w-100-p">
    <span #ruler class="ruler"></span>
    <div [class.hidden]="initialLoad">
        <mat-table #table [dataSource]="dataSource" matSort matSortActive="{{ sortBy }}" matSortDirection="{{ sortOrder }}" [class.hidden]="isLoading">
            <!-- Avatar Column -->
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let module" class="avatar-cell cell-30 pl-20">
                    <div #avatarCell *ngIf="module.image; else noModuleImage">
                        <img class="avatar pointer" [alt]="module.name" [src]="module.image.thumbUrl" />
                    </div>
                    <ng-template #noModuleImage>
                        <div #avatarCell>
                            <div class="avatar pointer module-icon-container no-image">
                                <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                            </div>
                        </div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="pr-12" *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" class="pr-12" fxLayout="column" fxLayoutAlign="center stretch">
                    <!-- Always in the cell (not *ngIf) so filterTags can measure a real column width. -->
                    <div #tagsMeasure class="tags-width-measure" aria-hidden="true"></div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="name-with-type-icon w-100-p min-w-0">
                        <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="module | getModuleIcon"></mat-icon>
                        <span class="text-truncate font-medium min-w-0" [tooltipIfTruncated]="module.name">{{ module.name }}</span>
                    </div>
                    <div
                        class="tags-row w-100-p relative z-[2]"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        *ngIf="module.tags.length"
                        (click)="$event.stopPropagation()"
                    >
                        <ng-container *ngIf="module.tags | filterTags: tagsMeasure:this:tagsLayoutKey as visibleTags">
                            <mat-chip-set class="mr-8 py-0" [class.has-more]="visibleTags.length < module.tags.length">
                                <mat-chip
                                    *ngFor="let tag of visibleTags"
                                    (click)="filterByTag(tag); $event.preventDefault(); $event.stopPropagation()"
                                    class="pointer"
                                    [style.background]="tag.color"
                                    [disableRipple]="true"
                                >
                                    {{ tag.name }}
                                </mat-chip>
                            </mat-chip-set>

                            <ng-container *ngIf="visibleTags.length < module.tags.length">
                                <div #more class="more-tags" (click)="$event.preventDefault(); $event.stopPropagation()">...</div>
                                <app-tags-card [tags]="module.tags" [target]="more" (clickedTag)="filterByTag($event)"></app-tags-card>
                            </ng-container>
                        </ng-container>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Version Column -->
            <ng-container matColumnDef="version">
                <mat-header-cell *matHeaderCellDef class="pl-24">
                    <span class="text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.VERSION' | translate }}</span>
                </mat-header-cell>
                <mat-cell #nameCell *matCellDef="let module" class="pl-24">
                    <p
                        #el
                        class="text-truncate"
                        [matTooltip]="module.version ? module.version : '-'"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.version ? module.version : '-' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Module Type Column -->
            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p
                        #el
                        class="text-truncate"
                        translate
                        [matTooltip]="(module.type === 'e_learning' ? 'MODULE.TYPE.E-LEARNING' : 'MODULE.TYPE.BASIC') | translate"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.type === 'e_learning' ? 'MODULE.TYPE.E-LEARNING' : 'MODULE.TYPE.BASIC' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.START_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p
                        #el
                        class="text-truncate"
                        [matTooltip]="module.startDate | date: 'shortDate'"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.startDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.END_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p
                        #el
                        class="text-truncate"
                        [matTooltip]="module.endDate | date: 'shortDate'"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.endDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Created At Column -->
            <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.CREATED_ON' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p
                        #el
                        class="text-truncate"
                        [matTooltip]="module.createdAt ? (module.createdAt | date: 'short') : '-'"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.createdAt ? (module.createdAt | date: 'short') : '-' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Updated At Column -->
            <ng-container matColumnDef="updatedAt">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.LAST_MODIFIED' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p
                        #el
                        class="text-truncate"
                        [matTooltip]="module.updatedAt ? (module.updatedAt | date: 'short') : '-'"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.updatedAt ? (module.updatedAt | date: 'short') : '-' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Responsible Column -->
            <ng-container matColumnDef="responsible">
                <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.RESPONSIBLE_MANAGERS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p #el class="text-truncate" [matTooltip]="el.innerText" [matTooltipDisabled]="el.scrollWidth <= el.clientWidth" [matTooltipShowDelay]="500">
                        <span class="value" *ngFor="let manager of module.responsibleManagers; first as isFirst">
                            {{ isFirst ? '' : ',' }}&nbsp;{{ manager.firstName }} {{ manager.lastName }}
                        </span>
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Participants Column -->
            <ng-container matColumnDef="numberOfParticipants">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.NUMBER_OF_PARTICIPANTS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p #el class="text-truncate" [matTooltip]="module.numberOfParticipants" [matTooltipDisabled]="el.scrollWidth <= el.clientWidth" [matTooltipShowDelay]="500">
                        {{ module.numberOfParticipants }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Status column -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="status">{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" class="status">
                    <p
                        #el
                        class="text-truncate py-4 px-12 rounded-full text-xs"
                        [style.background-color]="module.status | getStatus: moduleStatuses:'primaryColor'"
                        [matTooltip]="module.status | getStatus: moduleStatuses:'translationLabel' | translate"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ module.status | getStatus: moduleStatuses:'translationLabel' | translate }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Extended Attributes Columns -->
            <ng-container *ngFor="let attribute of extendedAttributes" [matColumnDef]="attribute.name">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs class="active-user-list-mat-header">
                    {{ attribute.translationKey | translate }}</mat-header-cell
                >
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-xs>
                    <p
                        #el
                        class="text-truncate pr-4"
                        [matTooltip]="attribute | getUserExtendedAttributeValue: module.allAttributes"
                        [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ attribute | getUserExtendedAttributeValue: module.allAttributes }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef>
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <mat-form-field class="executions-columns-trigger">
                            <mat-icon matPrefix svgIcon="table_columns_dropdown"></mat-icon>
                            <mat-select #columnsSelect [formControl]="tableColumnsDropdown" multiple panelClass="executions-columns-panel" (openedChange)="onColumnsDropdownOpenedChange($event)">
                                <div class="columns-options-scroll">
                                    <ng-container *ngFor="let column of possibleTableColumns">
                                        <mat-option *ngIf="column.translation && column.id !== 'avatar' && column.id !== 'buttons'" [value]="column.id">
                                            {{ column.translation | translate }}
                                        </mat-option>
                                    </ng-container>
                                </div>
                                <footer class="apply-columns-footer" (click)="$event.stopPropagation()">
                                    <button mat-flat-button color="primary" class="w-100-p" (click)="applyColumns()">
                                        {{ 'GENERAL.BUTTON.APPLY' | translate }}
                                    </button>
                                </footer>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let module"> </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
                *matRowDef="let module; columns: displayedColumns"
                class="relative group pointer hover:bg-gray-50"
                matRipple
                (click)="goToModule(module)"
            >
            </mat-row>
        </mat-table>

        <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
            <div class="shimmer-container min-w-full p-0">
                <div class="shimmer p-12">
                    <div class="shimmer-card !max-w-full table h-480 animate"></div>
                </div>
            </div>
        </div>

        <mat-paginator persistPageSize="all-modules.executions-list" [length]="totalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
    </div>

    <div *ngIf="initialLoad">
        <div class="shimmer-container min-w-full">
            <div class="shimmer p-12">
                <div class="shimmer-card table animate"></div>
            </div>
        </div>
    </div>
</div>
